export class ApiObjHitrateCustomField {
    
    id: number;
    name: string;

    constructor(data: any) {
        this.id = parseInt(data.id);
        this.name = data.name;
    }
}